import AnswerDTO from '../interfaces/dto/answerDTO';
import { AnswerShape, MappedAnswer } from '../components/context/SurveyPageContext';
import { QuestionType } from '../interfaces/questionType';

interface ReducedAnswer {
  answer: AnswerDTO;
}

const reducedAnswer = ({ answer }: ReducedAnswer): AnswerShape => {
  const questionType = answer.question.type;
  switch (questionType) {
    case QuestionType.TEXTAREA_IN:
    case QuestionType.DATE_IN:
    case QuestionType.FILL_IN:
      return { value: answer.value || '' };
    case QuestionType.CHOOSE_MANY:
      return { choices: answer.choices.map((choice) => ({ id: choice.id })) };
    default: // QuestionType.RADIO_BUTTON || QuestionType.RADIO_COLOR || QuestionType.SELECT_SIMPLE:
      if (
        questionType === QuestionType.RADIO_BUTTON &&
        !answer.chosenOption &&
        answer.value !== null
      ) {
        return { value: answer.value || '' };
      }
      return {
        chosenOption: answer.chosenOption?.id ? { id: answer.chosenOption?.id } : null,
      };
  }
};

interface MapAnswers {
  answers: AnswerDTO[];
}

const mapAnswers = ({ answers }: MapAnswers): Map<number, MappedAnswer> =>
  answers.reduce((map, answer) => {
    const questionId = answer.question.id;
    map.set(questionId, {
      question: { id: questionId },
      ...reducedAnswer({ answer }),
    });

    return map;
  }, new Map());

export { mapAnswers };
